import { useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';

import { BaseLoaderSpinner } from '..';
import { confirmAccount } from '../../misc/requests';
import { successToast, warningToast } from '../../store/slices/toaster.slice';
import errorService, { ErrorService } from '../../helpers/errors.helper';

const CONFIRMATION_ERRORS = {
  [ErrorService.ERRORS.USER_ALREADY_ACTIVATED]: {
    type: 'warning',
    title: 'common:confirmAccount.errors.errorTitle',
    content: 'common:confirmAccount.errors.alreadyConfirmed',
  },
  [ErrorService.ERRORS.UNDECODABLE_VALUE]: {
    type: 'warning',
    title: 'common:confirmAccount.errors.errorTitle',
    content: 'common:confirmAccount.errors.wrongUserId',
  },
  [ErrorService.ERRORS.INVALID_EMAIL_CONFIRMATION_TOKEN]: {
    type: 'warning',
    title: 'common:confirmAccount.errors.errorTitle',
    content: 'common:confirmAccount.errors.wrongToken',
  },
  [ErrorService.ERRORS.DOES_NOT_EXIST]: {
    type: 'warning',
    title: 'common:confirmAccount.errors.errorTitle',
    content: 'common:confirmAccount.errors.userNotFound',
  },
};

const UserAccountConfirmation = () => {
  const { t: common } = useTranslation('common');

  const location = useLocation();

  const navigate = useNavigate();

  const confirmUser = useCallback(
    async (user_id, token) => {
      try {
        if (user_id && token) {
          await confirmAccount({ user_id, token });
          successToast(common('confirmAccount.successContent'), common('confirmAccount.successTitle'));
        } else {
          warningToast(common('confirmAccount.errors.default'), common('confirmAccount.errors.errorTitle'));
        }
      } catch (error) {
        errorService.handleErrorToast(error, CONFIRMATION_ERRORS);
      } finally {
        navigate('/login');
      }
    },
    [common, navigate]
  );

  useEffect(() => {
    const { user_id, token } = queryString.parse(location.search);
    confirmUser(user_id, token);
  }, [confirmUser, location.search]);

  return <BaseLoaderSpinner large />;
};

export default UserAccountConfirmation;
